import { render } from "./NavTabs.vue?vue&type=template&id=422ec59b"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elliot/Documents/attendance-systems/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__